export default __webpack_public_path__ + "static/communitytwo-c4741dd91685687b5a70272b3562e2ac.png";